import { render, staticRenderFns } from "./build2.vue?vue&type=template&id=3c0d2e73&scoped=true&"
import script from "./build2.vue?vue&type=script&lang=js&"
export * from "./build2.vue?vue&type=script&lang=js&"
import style0 from "./build2.vue?vue&type=style&index=0&id=3c0d2e73&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0d2e73",
  null
  
)

export default component.exports